export const SET_REGISTER = "setRegister";

export default {
  state: {
    register: {
      'weight' : 0,
      'height' : 0,
      'latitude' : process.env.VUE_APP_LAT,
      'longitude' : process.env.VUE_APP_LNG
    },
  },
  getters: {
    getRegister(state) {
      return state.register;
    },
  },
  actions: {
    [SET_REGISTER](state, payload) {
      state.commit(SET_REGISTER, payload);
    },
  },
  mutations: {
    [SET_REGISTER](state, payload) {
      state.register = {
        ...state.register,
        ...payload,
      };
    },
  },
};
